import type { SessionResultsPlayItem } from "./use-session-results.types";

export const createScenarioRetryAttemptId = (cryptoSource: Partial<Pick<Crypto, "randomUUID">> | undefined = globalThis.crypto): string =>
  cryptoSource?.randomUUID?.() ?? `retry-${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const buildScenarioRetryPayload = (playItem: SessionResultsPlayItem | undefined) => {
  const config = playItem?.play_mode_config;
  if (!playItem?.scenario_doc_id || !config || !Number.isFinite(config.game_speed) || config.game_speed <= 0) {
    return null;
  }

  return {
    record_results: false,
    play_session_id: 0,
    is_staging: false,
    items: [
      {
        scenario_id: typeof playItem.scenario_id === "number" ? playItem.scenario_id : undefined,
        scenario_doc_id: playItem.scenario_doc_id,
        cognitive_result_id: 0,
        play_mode_config: { ...config },
        styles: playItem.styles,
      },
    ],
  };
};
